// extracted by mini-css-extract-plugin
module.exports = {"lightYoutube":"style-module--lightYoutube--1AMIv","title":"style-module--title--cV2aa","gradient":"style-module--gradient--1xGox","play":"style-module--play--3IMuI"};